'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInitialMessage = undefined;

var _commonMessageFormatGetters = require('../../common-message-format/operators/commonMessageFormatGetters');

var _messageType = require('../constants/messageType');

var isInitialMessage = exports.isInitialMessage = function isInitialMessage(message) {
  return (0, _commonMessageFormatGetters.getTopLevelType)(message) === _messageType.INITIAL_MESSAGE;
};